import { Module, ActionTree, MutationTree, GetterTree } from 'vuex'
const state = {
    max_upload_num:{
        'default':6
    }
}

const mutations = {
  SET_DATA: (state, [key, value]) => {
      state[key] = value
  },
  SET_MAX_NUM: (state, [key, value]) => {
    state[key] = Object.assign(state[key],value)
    // console.log(state,'state')
  }
}

const actions = {
}
const getters = {
    max_upload_num: (state) => state.max_upload_num
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
